import { Injectable, Injector } from '@angular/core'
import { Router } from '@angular/router'
import { ShortcutGridHosts } from './shortcut-grid-hosts.service'
import { ShortcutRegistryService } from './shortcut-registry.service'
import { UserBinding } from './shortcut.types'

/** Turns a user-defined action binding into a handler. */
@Injectable({ providedIn: 'root' })
export class ShortcutActionService {
    constructor (private router: Router, private injector: Injector) { }

    runnerFor (binding: UserBinding): (e?: KeyboardEvent) => void {
        const action = binding.action
        if (!action) return () => { }
        const p = action.payload ?? {}

        switch (action.type) {
            case 'navigate':
                return () => {
                    const url = String(p['url'] ?? '')
                    // Internal routes only: never javascript:, never off-site
                    if (url.startsWith('/') && !url.startsWith('//')) this.router.navigateByUrl(url)
                }
            case 'command':
                // Lazy: the registry depends on this service
                return () => this.injector.get(ShortcutRegistryService).runCommand(String(p['commandId'] ?? ''))
            case 'grid-view':
                return () => this.injector.get(ShortcutGridHosts).applyView(Number(p['view_id']))
            case 'focus':
                return () => {
                    const el = document.querySelector<HTMLElement>(String(p['selector'] ?? ''))
                    el?.focus()
                    if (el instanceof HTMLInputElement) el.select()
                }
            default:
                // macro is a separate feature, not wired yet
                return () => console.warn(`Shortcut action "${action.type}" is not supported yet`)
        }
    }
}
